import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import moment from 'moment';

const UpdatedField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	const inputValue = customerForFullInfo?.updatedDate
		? `${moment(customerForFullInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')}      ${
				customerForFullInfo.updatedBy
		  }`
		: undefined;

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};

export default UpdatedField;
